import { useMemo } from 'react';

export interface DeviceDetection {
  isDesktop: boolean;
  isTablet: boolean;
  isPhone: boolean;
  isDesktopOrTablet: boolean;
  isIPad: boolean;
  isAndroidTablet: boolean;
}

/**
 * Hook to detect device type based on user agent and browser capabilities
 * Returns device detection flags for desktop, tablet, and phone
 */
export const useDeviceDetection = (): DeviceDetection => {
  return useMemo(() => {
    const ua = navigator.userAgent;

    // Check for iPad (including modern iPads that report as Macintosh)
    const isIPad =
      ua.includes('iPad') || (ua.includes('Macintosh') && !!navigator.maxTouchPoints && navigator.maxTouchPoints > 1);

    // Check for Android tablets
    const isAndroidTablet = ua.includes('Android') && !ua.includes('Mobile');

    // Combined tablet detection
    const isTablet = isIPad || isAndroidTablet;

    // Check for phone
    const isPhone = /iPhone|Android/i.test(ua) && !/(iPad|tablet)/i.test(ua);

    // Check for desktop (not a mobile device and uses precise pointer)
    const isDesktop = !/iPhone|iPad|iPod|Android/i.test(ua) && !window.matchMedia('(pointer: coarse)').matches;

    // Combined desktop or tablet
    const isDesktopOrTablet = isDesktop || isTablet;

    return {
      isDesktop,
      isTablet,
      isPhone,
      isDesktopOrTablet,
      isIPad,
      isAndroidTablet,
    };
  }, []);
};
